export function generateColors(numColors: number, seedColor = { h: 341, s: 78, l: 51 }) {
  const hueDistance = 360 / numColors;

  const SATURATION_MIN = 50;
  const SATURATION_MAX = 100;
  const SATURATION_PARTITIONS = 3;
  const saturationRange = SATURATION_MAX - SATURATION_MIN;
  const saturationDistance = saturationRange / SATURATION_PARTITIONS;

  const LIGHTNESS_MIN = 40;
  const LIGHTNESS_MAX = 85;
  const LIGHTNESS_PARTITIONS = 3;
  const lightnessRange = LIGHTNESS_MAX - LIGHTNESS_MIN;
  const lightnessDistance = lightnessRange / LIGHTNESS_PARTITIONS;

  const colors = [seedColor];

  for (let i = 1; i < numColors; i++) {
    colors.push({
      h: (seedColor.h + hueDistance * i) % 360,
      s: SATURATION_MIN + ((saturationDistance * i) % saturationRange),
      l: LIGHTNESS_MIN + ((lightnessDistance * i) % lightnessRange),
    });
  }

  return colors;
}
